export const NEXI_API_URL = process.env.NEXI_API_URL
export const NEXI_API_KEY = process.env.NEXI_API_KEY

export const NEXI_AUTH_HEADERS = {
  Authorization: NEXI_API_KEY || ''
}
